import OneOffPaymentService from '../OneOffPaymentUtil'
import { CreateOrUpdateOneOffPaymentMutation, DeleteOneOffPaymentMutation, OneOffPayment, OneOffPaymentInput } from '../../../types'
import { GraphQLFormattedError } from 'graphql'

export default (
  meetingId: number,
): {
  deleteOneOffPayment: (oneOffPaymentId: number) => Promise<{
    data: DeleteOneOffPaymentMutation | null | undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors: readonly GraphQLFormattedError<Record<string, any>>[] | undefined
  }>
  saveOneOffPayment: (oneOffPayment: OneOffPaymentInput) => Promise<{
    data: CreateOrUpdateOneOffPaymentMutation | null | undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors: readonly GraphQLFormattedError<Record<string, any>>[] | undefined
  }>
  transformToInput: (oneOffPayment: OneOffPayment | null) => OneOffPaymentInput
} => {
  const deleteOneOffPayment = async (oneOffPaymentId: number) => {
    const { data, errors } = await OneOffPaymentService.mutateDeleteOneOffPayment(oneOffPaymentId, meetingId)
    return { data, errors }
  }
  const saveOneOffPayment = async (oneOffPayment: OneOffPaymentInput) => {
    const { data, errors } = await OneOffPaymentService.mutateCreateOrUpdateOneOffPayment(oneOffPayment, meetingId)
    return { data, errors }
  }
  return {
    deleteOneOffPayment,
    saveOneOffPayment,
    transformToInput: OneOffPaymentService.transformToInput,
  }
}
